var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import _ from 'lodash';
import { Component, Watch } from 'vue-property-decorator';
import { Loading } from 'element-ui';
import VueDialog from "../../../../interface/IVueDialog";
import BasicArcheivesService from '../../../../api/BasicArcheivesService';
import CommonService from '../../../../api/CommonService';
import DeliverService from '../../../../api/DeliverService';
import GoodService from "../../../../api/GoodService";
import AddGoodTable from "./TabTable.vue";
var EActiveType;
(function (EActiveType) {
    EActiveType["UN_SELECTED"] = "0";
    EActiveType["SELECTED"] = "1";
})(EActiveType || (EActiveType = {}));
export var EOrderType;
(function (EOrderType) {
    EOrderType[EOrderType["ORDER"] = 0] = "ORDER";
    EOrderType[EOrderType["NO_ORDER"] = 1] = "NO_ORDER";
    EOrderType[EOrderType["RETAIL"] = 2] = "RETAIL";
})(EOrderType || (EOrderType = {}));
var AddGoods = (function (_super) {
    __extends(AddGoods, _super);
    function AddGoods() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.treeData = [];
        _this.tableData = [];
        _this.total = 0;
        _this.curGoodNode = [];
        _this.activeName = '0';
        _this.selectRows = [];
        _this.EActiveType = EActiveType;
        _this.unSelectList = [];
        _this.selectedList = [];
        _this.canFreshTable = true;
        _this.formData = {};
        _this.target = {};
        _this.categoryData = [];
        _this.searchFromData = {
            goods_type_ids: null,
            show_stock_goods: 0,
            keyword: ''
        };
        return _this;
    }
    AddGoods.prototype.watchShowStockGoods = function (newValue, oldValue) {
        this.search();
    };
    AddGoods.prototype.created = function () {
        this.goodService = GoodService.getInstance();
        this.service = BasicArcheivesService.getInstance();
        this.commonService = CommonService.getInstance();
        this.deliverService = DeliverService.getInstance();
        console.log(999, this.target, this.addedDatas);
        if (this.addedDatas) {
            this.selectedList = _.cloneDeep(this.addedDatas ? this.addedDatas : []);
        }
        this.getCategory();
        this.getGoodsList();
    };
    AddGoods.prototype.mounted = function () {
    };
    AddGoods.prototype.goodsTypeSelect = function (node) {
        this.searchFromData.goods_type_ids = node.goods_type_id;
        this.search();
    };
    AddGoods.prototype.getCategory = function () {
        var _this = this;
        this.goodService.getCategory().then(function (res) {
            if (res.data.success) {
                _this.categoryData = res.data.data;
            }
            else {
                _this.$message.error(res.data.msg);
            }
        }, function (err) {
            _this.$message.error(err.message || err.msg);
        }).catch(function (err) {
            _this.$message.error(err.message);
        });
    };
    AddGoods.prototype.getGoodsList = function (pager) {
        var _this = this;
        if (pager === void 0) { pager = { page: 1, start: 0, limit: 20 }; }
        var loadingInstance = Loading.service({ fullscreen: true });
        var goods_format_id;
        goods_format_id = (this.selectedList || []).map(function (item) {
            return item.goods_format_id;
        });
        var params = {
            business_id: this.formData.business_id,
            out_depot_id: this.formData.out_depot_id,
            keyword: this.searchFromData.keyword,
            goods_type_ids: this.searchFromData.goods_type_ids,
            show_stock_goods: 1,
            order_type: this.formData.order_type,
            shop_id: this.formData.shop_id,
            organ_id: this.formData.organ_id,
            selected_goods_format_ids: goods_format_id,
        };
        this.deliverService.getGoodsList(Object.assign({}, params, pager)).then(function (res) {
            if (res.data.success) {
                var data = res.data.data || [];
                data.length && data.forEach(function (item) {
                    item.order_detail_oamount = 0;
                    item.order_detail_uprice = item.order_detail_uprice ? item.order_detail_uprice : 0;
                    item.order_detail_money = 0;
                    item.order_detail_tax_money = 0;
                    item.money = 0;
                });
                _this.tableData = data;
                _this.unSelectList = data;
                _this.total = res.data.total || 0;
                _this.setSelected(true);
            }
            loadingInstance.close();
        }, function (err) {
            _this.$message.error(err.message);
            loadingInstance.close();
        }).catch(function (err) {
            _this.$message.error(err.msg || err.message);
            loadingInstance.close();
        });
    };
    AddGoods.prototype.selectChange = function (rows, currentRow, isSelectAll) {
        var _this = this;
        if (isSelectAll === void 0) { isSelectAll = false; }
        var currentSelectRows = _.filter(rows, function (row) { return !!row; });
        console.log('currentSelectRows', currentSelectRows);
        console.log('this.formData.order_type', this.formData.order_type);
        console.log('EOrderType.NO_ORDER', EOrderType.NO_ORDER);
        this.selectedList = _.uniqBy(this.selectedList.concat(currentSelectRows), 'goods_format_id');
        var isUnselectAll = !currentSelectRows.length && !currentRow && isSelectAll;
        if (currentRow && !_.find(currentSelectRows, function (good) { return good.goods_format_id === currentRow.goods_format_id; })) {
            _.remove(this.selectedList, function (good) { return good.goods_format_id === currentRow.goods_format_id; });
        }
        else if (isUnselectAll && this.activeName === EActiveType.SELECTED) {
            this.selectedList = [];
        }
        else if (isUnselectAll) {
            this.unSelectList.forEach(function (good) {
                _.remove(_this.selectedList, function (item) { return item.goods_format_id === good.goods_format_id; });
            });
        }
        this.setSelected(this.activeName === EActiveType.SELECTED);
        setTimeout(function () {
            _this.canFreshTable = true;
            var pagination = _this.$refs.pagination;
            _this.getGoodsList(pagination.getPage());
        });
    };
    AddGoods.prototype.handleClick = function (tab, event) {
        if (tab.name == "second") {
            this.setSelected();
        }
    };
    AddGoods.prototype.setSelected = function (isUnSelFresh) {
        var _this = this;
        if (isUnSelFresh === void 0) { isUnSelFresh = false; }
        var gridTable = this.$refs.grid.$refs.table;
        if (isUnSelFresh) {
            gridTable.clearSelection();
        }
        if (!this.selectedList.length) {
            this.$refs.alreadyGrid.$refs.table.clearSelection();
        }
        else {
            this.selectedList.forEach(function (good, index) {
                _this.$nextTick(function () {
                    _this.$refs.alreadyGrid.$refs.table.toggleRowSelection(good, true);
                });
                if (isUnSelFresh) {
                    var item_1;
                    item_1 = _.find(_this.unSelectList, function (current) { return current.goods_format_id === good.goods_format_id; });
                    _this.$nextTick(function () {
                        gridTable.toggleRowSelection(item_1, true);
                    });
                }
            });
        }
    };
    AddGoods.prototype.search = function () {
        var pagination = this.$refs.pagination;
        pagination.clear();
        this.getGoodsList();
    };
    AddGoods.prototype.close = function () {
        this.$closeDialog();
        this.$emit('closeDiolog', false);
    };
    AddGoods.prototype.save = function () {
        if (this.selectedList.length == 0) {
            this.$message.error('请选择一项货品进行替换！');
            return;
        }
        var that = this;
        this.debounce(function () {
            that.$closeDialog();
            that.$emit('save:ok', that.selectedList);
        });
    };
    AddGoods.prototype.debounce = function (cb) {
        clearTimeout(this.timer);
        this.timer = setTimeout(function () {
            cb();
        }, 500);
    };
    AddGoods.prototype.nodeClick = function (node) {
        this.curGoodNode = node || null;
        this.getGoodsList();
    };
    AddGoods.prototype.pageChange = function (pager) {
        this.getGoodsList(pager);
        this.$refs.grid.$refs.table.bodyWrapper.scrollTop = 0;
    };
    AddGoods.prototype.normalizer = function (node) {
        return {
            id: node.goods_type_id,
            label: node.goods_type_name,
            children: node.children,
        };
    };
    __decorate([
        Watch("searchFromData.show_stock_goods")
    ], AddGoods.prototype, "watchShowStockGoods", null);
    AddGoods = __decorate([
        Component({
            components: {
                'add-good-table': AddGoodTable
            }
        })
    ], AddGoods);
    return AddGoods;
}(VueDialog));
export default AddGoods;
